import html2pdf from 'html2pdf.js';
import { buildTemplate } from './pdfTemplate.js';

// Resolve asset URLs for use inside the HTML-to-PDF template
const logoUrl = new URL('../assets/logo.svg', import.meta.url).toString();

const fetchSvgAsDataUrl = async (url) => {
  try {
    const res = await fetch(url, { cache: 'force-cache' });
    const svg = await res.text();
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  } catch (e) {
    console.warn('Failed to inline SVG, falling back to url', e);
    return url;
  }
};

const createHtmlTemplate = (store, assets) => buildTemplate(store, assets);

export const downloadPDF = async (store) => {
  try {
    console.log('Generating PDF with image URL:', store.imageUrl);
    
    // Inline the SVG logo to avoid cross-origin issues
    const logoDataUrl = await fetchSvgAsDataUrl(logoUrl);
    // Create HTML content
    const htmlContent = createHtmlTemplate(store, { logoUrl: logoDataUrl });
    
    // Create a temporary element to hold the HTML
    const element = document.createElement('div');
    element.innerHTML = htmlContent;
    
    // Configure html2pdf options
    const options = {
      margin: 10,
      filename: `medical-report-${new Date().toISOString().split('T')[0]}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
        scale: 2,
        useCORS: true,
        letterRendering: true,
        allowTaint: true,
        logging: false
      },
      jsPDF: { 
        unit: 'mm', 
        format: 'a4', 
        orientation: 'portrait' 
      },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    
    // Generate PDF, then add footers on every page before saving
    await html2pdf()
      .set(options)
      .from(element)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const pageCount = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        // Normalize footer font so it matches and does not look stretched
        pdf.setFont('helvetica', 'normal');
        pdf.setFontSize(9);
        pdf.setTextColor(90);
        for (let i = 1; i <= pageCount; i++) {
          pdf.setPage(i);
          const y = pageHeight - 8;
          const centerText = 'https://www.antibiomic.com  |  contact@antibiomic.com';
          // Center footer text
          pdf.text(centerText, pageWidth / 2, y, { align: 'center' });
          // Right-aligned page number
          pdf.text(`Page ${i} / ${pageCount}`, pageWidth - 8, y, { align: 'right' });
        }
      })
      .save();
    console.log('PDF generated successfully');
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
}; 